var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrdered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875 15C21.7092 15 21.5503 14.9342 21.4331 14.8169C21.3158 14.6997 21.25 14.5408 21.25 14.375V8.125C21.25 6.96468 20.7891 5.85188 19.9686 5.03141C19.1481 4.21094 18.0353 3.75 16.875 3.75C15.7147 3.75 14.6019 4.21094 13.7814 5.03141C12.9609 5.85188 12.5 6.96468 12.5 8.125V14.375C12.5 14.5408 12.4342 14.6997 12.3169 14.8169C12.1997 14.9342 12.0408 15 11.875 15C11.7092 15 11.5503 14.9342 11.4331 14.8169C11.3158 14.6997 11.25 14.5408 11.25 14.375V8.125C11.25 6.63316 11.8426 5.20242 12.8975 4.14752C13.9524 3.09263 15.3832 2.5 16.875 2.5C18.3668 2.5 19.7976 3.09263 20.8525 4.14752C21.9074 5.20242 22.5 6.63316 22.5 8.125V14.375C22.5 14.5408 22.4342 14.6997 22.3169 14.8169C22.1997 14.9342 22.0408 15 21.875 15Z",
    fill: "#DADCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.125 36.875H1.875L3.125 11.875H21.875L23.125 36.875Z",
    fill: "#EB423F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.125 36.875H23.125L21.875 11.875H26.875L28.125 36.875Z",
    fill: "#D13330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6617 33.7492C25.6492 33.75 25.6367 33.75 25.6242 33.75C25.4649 33.7499 25.3116 33.6889 25.1958 33.5796C25.0799 33.4702 25.0101 33.3208 25.0008 33.1617L23.7508 11.9117C23.75 11.8992 23.75 11.8875 23.75 11.875H25.0016L26.2492 33.0883C26.2589 33.2538 26.2024 33.4164 26.0923 33.5404C25.9821 33.6643 25.8272 33.7394 25.6617 33.7492Z",
    fill: "#A82A27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.125 36.875H33.125L33.0469 35.8648V35.8641L31.875 20.625H36.875L38.0273 35.6008V35.6016L38.125 36.875Z",
    fill: "#EBA72E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6875 33.7469C35.6665 33.7491 35.6454 33.7501 35.6242 33.75C35.4694 33.7498 35.3202 33.6922 35.2055 33.5883C35.0907 33.4843 35.0186 33.3415 35.0031 33.1875L34.9805 32.9641L33.7531 20.6875C33.7509 20.6667 33.7499 20.6459 33.75 20.625H35.0031L36.2313 32.907L36.2469 33.0625C36.2551 33.1442 36.2471 33.2267 36.2235 33.3052C36.1998 33.3838 36.1609 33.457 36.1089 33.5205C36.057 33.5841 35.993 33.6368 35.9207 33.6756C35.8484 33.7145 35.7692 33.7387 35.6875 33.7469Z",
    fill: "#E09F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.125 36.875H37.3734L35.625 34.2516L33.8766 36.875H33.125L33.0469 35.8649V35.8641L34.9805 32.9641L35.1047 32.7781C35.1619 32.6926 35.2393 32.6224 35.33 32.5739C35.4208 32.5254 35.5221 32.5 35.625 32.5C35.7279 32.5 35.8292 32.5254 35.92 32.5739C36.0107 32.6224 36.0881 32.6926 36.1453 32.7781L36.2313 32.907L38.0273 35.6008V35.6016L38.125 36.875Z",
    fill: "#E09F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.125 36.875H16.875L18.125 20.625H31.875L33.125 36.875Z",
    fill: "#F7B030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.375H8.75V18.125H7.5V14.375Z",
    fill: "#DADCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 15C7.95924 15 7.80027 14.9342 7.68306 14.8169C7.56585 14.6997 7.5 14.5408 7.5 14.375V8.125C7.5 6.63316 8.09263 5.20242 9.14752 4.14752C10.2024 3.09263 11.6332 2.5 13.125 2.5C14.6168 2.5 16.0476 3.09263 17.1025 4.14752C18.1574 5.20242 18.75 6.63316 18.75 8.125V14.375C18.75 14.5408 18.6842 14.6997 18.5669 14.8169C18.4497 14.9342 18.2908 15 18.125 15C17.9592 15 17.8003 14.9342 17.6831 14.8169C17.5658 14.6997 17.5 14.5408 17.5 14.375V8.125C17.5 6.96468 17.0391 5.85188 16.2186 5.03141C15.3981 4.21094 14.2853 3.75 13.125 3.75C11.9647 3.75 10.8519 4.21094 10.0314 5.03141C9.21094 5.85188 8.75 6.96468 8.75 8.125V14.375C8.75 14.5408 8.68415 14.6997 8.56694 14.8169C8.44973 14.9342 8.29076 15 8.125 15Z",
    fill: "#E9EEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 23.125H6.25V18.125L8.125 16.875L10 18.125V23.125Z",
    fill: "#F7B030"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 22,
    r: 8,
    fill: "#1BC186"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0938 25.5078C25.8828 25.5078 25.6875 25.4219 25.5391 25.2812L22.8125 22.5547C22.5078 22.25 22.5078 21.7578 22.8125 21.4531C23.1172 21.1484 23.6094 21.1484 23.9141 21.4531L26.0859 23.625L30.9922 18.7187C31.2969 18.4141 31.7891 18.4141 32.0938 18.7187C32.3984 19.0234 32.3984 19.5156 32.0938 19.8203L26.6406 25.2812C26.5 25.4297 26.2969 25.5078 26.0938 25.5078Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdered);
export default __webpack_public_path__ + "static/media/ordered.056c5c1e45518cf17a863052c2dc3d42.svg";
export { ForwardRef as ReactComponent };